var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLandscape = function SvgLandscape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1364,
    height: 995,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.5h72.4c31.8 0 57.6 25.8 57.6 57.6v83.8c0 31.8 25.8 57.6 57.6 57.6h52.8c31.8 0 57.6 25.8 57.6 57.6v160.8c0 31.8 25.8 57.6 57.6 57.6H378c65.7 0 119 53.3 119 119v174.2c0 17.6 14.2 31.8 31.8 31.8h23.6c51.7 0 93.6 41.9 93.6 93.6v96.4",
    stroke: "#C7AA3D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "96 12 0.5 12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M528.5 928v-29.9c0-35.4-28.7-64.1-64.1-64.1h-29.8c-35.4 0-64.1-28.7-64.1-64.1V576.1c0-35.4-28.7-64.1-64.1-64.1h-37.8c-35.4 0-64.1-28.7-64.1-64.1V319.1c0-35.4-28.7-64.1-64.1-64.1-14.3 0-25.9-11.6-25.9-25.9",
    stroke: "#C7AA3D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "24 12 0.5 12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M167.5 429.1c0 59.6 28.3 107.9 87.9 107.9h17.1c33.7 0 61.1 27.3 61.1 61.1v186.2c0 46.2 37.5 83.7 83.7 83.7 21.7 0 39.3 17.6 39.3 39.3V954M413.5 691v77.3c0 21.9 17.8 39.7 39.7 39.7h30.3",
    stroke: "#C7AA3D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "24 12 0.5 12"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m474.8 507.6.6 1.3c.3.7 1.2 1 1.9.7.7-.3 1-1.2.7-1.9l-.6-1.3c-.3-.7-1.2-1-1.9-.7-.8.4-1.1 1.2-.7 1.9Z",
    fill: "#C7AA3D",
    stroke: "#C7AA3D",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M416.5 505h8.5c6.9 0 12.5 5.6 12.5 12.5S443.1 530 450 530h4c6.9 0 12.5 5.6 12.5 12.5V557",
    stroke: "#C7AA3D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "16 20 0.5 20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M467.6 406.6v-1.3",
    stroke: "#C7AA3D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5 634h36.7c53.2 0 96.3 43.1 96.3 96.3V846",
    stroke: "#C7AA3D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "24 12 0.5 12"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26 696.5h48.6c33.9 0 61.4 27.5 61.4 61.4v147.6",
    stroke: "#C7AA3D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "24 12 0.5 12"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 730.5h49c25.4 0 46 20.6 46 46M26 146.5v112c0 38.1 30.9 69 69 69",
    stroke: "#C7AA3D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "24 12 0.5 12"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1311 849.5c28.2 0 51 22.8 51 51v92M1311 838.5c0-19.9 16.1-36 36-36M1266 885.5c0-19.9 16.1-36 36-36M1304.8 840.9c-14.1-14.1-14.1-36.9 0-50.9M1306.2 906c-14.1-14.1-14.1-36.9 0-50.9",
    stroke: "#C7AA3D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1338.2 882.5c-13.8 0-25-11.2-25-25M1297.2 842.5c-13.8 0-25-11.2-25-25",
    stroke: "#C7AA3D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1191.3 885.415c0 1.2-2.8 2.3-6.3 2.3-2.2 0-4.1-.3-5.3-.9.3-.4.4-1 .4-1.5 0-.4-.1-.8-.2-1.1 1.1-.5 3-.9 5-.9 3.5-.1 6.3.8 6.4 2.1ZM1174.4 886.715c-1.1.6-3 .9-5 1-3.5 0-6.4-.9-6.4-2.1 0-1.2 2.8-2.3 6.3-2.3 2 0 3.9.3 5 .8-.2.4-.3.9-.3 1.3.1.4.2.9.4 1.3ZM1182.7 879.715c-1 1.7-2.2 3-3.3 3.7-.6-.7-1.4-1.1-2.4-1.1h-.1c.1-1.3.8-3.1 2-5 1.9-3 4.3-4.8 5.3-4.2 1 .7.3 3.6-1.5 6.6ZM1177.2 888.315v.3c0 1.3.7 3.2 1.9 5.1 1.8 3 4.1 5 5.2 4.3 1-.6.5-3.6-1.4-6.6-1.1-1.9-2.5-3.4-3.6-4.1-.5.6-1.2.9-2.1 1ZM1176.4 882.415c-.8.2-1.5.7-1.9 1.3-1.2-.6-2.6-2-3.9-4-1.9-2.9-2.6-5.9-1.6-6.5 1-.7 3.4 1.2 5.3 4.1 1.3 1.9 2 3.8 2.1 5.1Z",
    stroke: "#C7AA3D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1177.2 888.315h-.1c-1 0-1.8-.4-2.4-1.1-1 .7-2.2 2-3.2 3.7-1.9 3-2.6 5.9-1.5 6.6 1 .7 3.4-1.2 5.3-4.2 1.1-1.7 1.8-3.4 2-4.7-.1-.1 0-.2-.1-.3Z",
    stroke: "#C7AA3D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m785.6 825.3-1.3.5c-.7.3-1.5-.1-1.8-.9-.3-.7.1-1.5.9-1.8l1.3-.5c.7-.3 1.5.1 1.8.9.2.7-.2 1.5-.9 1.8Z",
    fill: "#C7AA3D",
    stroke: "#C7AA3D",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M793.2 823.9c1.6-.2 3.3.4 4.5 2.2M757 922.5l-2.5 69M754.6 922.5 741 951.6l29.1 13.9-2.6 6",
    stroke: "#C7AA3D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M793 825.2c0 3.9-3.1 7-7 7h-.1v60.2c0 16.3-13.2 29.5-29.5 29.5 0 0-25.2.2-33.5 1.5-1.9.3-7 3.1-7 3.1 0-14.3 8.1-28.8 20.8-37.7.9 1.7 2.1 3.2 3.5 4.6 3.8 3.8 9.2 6.2 15 6.2h2.1c6.8 0 16.2-5.5 16.2-12.2v-63.5c0-3.1 2.5-5.6 5.6-5.6h6.8c4-.1 7.1 3 7.1 6.9Z",
    stroke: "#C7AA3D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M825.977 772.072c-.183-1.303-1.458-2.234-2.732-2.048l-9.107 1.675c-1.093.186-2.004 1.304-2.004 2.421v13.591c-2.732-.558-5.646.745-6.921 4.469-.182.372-.182.745-.182 1.117-.364 3.538 2.55 6.703 6.01 6.703 3.097 0 5.647-2.42 6.011-5.586v-18.06l7.285-1.303c.911-.373 1.822-1.676 1.64-2.979Zm-15.3 22.901c-.729 0-1.275-.559-1.275-1.304 0-.744.546-1.303 1.275-1.303.729 0 1.275.559 1.275 1.303 0 .745-.546 1.304-1.275 1.304Z",
    fill: "#C7AA3D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M755.3 899.6h2.1c6.8 0 16.2-5.5 16.2-12.2v-9c0-.5-.4-.8-.8-.8h-37.9c-.5 0-.8.4-.8.8 0 11.7 9.5 21.2 21.2 21.2Z",
    stroke: "#C7AA3D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1221.3 915.415c0 1.2-2.8 2.3-6.3 2.3-2.2 0-4.1-.3-5.3-.9.3-.4.4-1 .4-1.5 0-.4-.1-.8-.2-1.1 1.1-.5 3-.9 5-.9 3.5-.1 6.3.8 6.4 2.1ZM1204.4 916.715c-1.1.6-3 .9-5 1-3.5 0-6.4-.9-6.4-2.1 0-1.2 2.8-2.3 6.3-2.3 2 0 3.9.3 5 .8-.2.4-.3.9-.3 1.3.1.4.2.9.4 1.3ZM1212.7 909.715c-1 1.7-2.2 3-3.3 3.7-.6-.7-1.4-1.1-2.4-1.1h-.1c.1-1.3.8-3.1 2-5 1.9-3 4.3-4.8 5.3-4.2 1 .7.3 3.6-1.5 6.6ZM1207.2 918.315v.3c0 1.3.7 3.2 1.9 5.1 1.8 3 4.1 4.9 5.2 4.3 1-.6.5-3.6-1.4-6.6-1.1-1.9-2.5-3.4-3.6-4.1-.5.6-1.2.9-2.1 1ZM1206.4 912.415c-.8.2-1.5.7-1.9 1.3-1.2-.6-2.6-2-3.9-4-1.9-2.9-2.6-5.9-1.6-6.5 1-.7 3.4 1.2 5.3 4.1 1.3 1.9 2 3.8 2.1 5.1Z",
    stroke: "#C7AA3D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1207.2 918.315h-.1c-1 0-1.8-.4-2.4-1.1-1 .7-2.2 2-3.2 3.7-1.9 3-2.6 5.9-1.5 6.6 1 .7 3.4-1.2 5.3-4.2 1.1-1.7 1.8-3.4 2-4.7-.1-.1 0-.2-.1-.3ZM1191.3 944.415c0 1.2-2.8 2.3-6.3 2.3-2.2 0-4.1-.3-5.3-.9.3-.4.4-1 .4-1.5 0-.4-.1-.8-.2-1.1 1.1-.5 3-.9 5-.9 3.5-.1 6.3.8 6.4 2.1ZM1174.4 945.715c-1.1.6-3 .9-5 1-3.5 0-6.4-.9-6.4-2.1 0-1.2 2.8-2.3 6.3-2.3 2 0 3.9.3 5 .8-.2.4-.3.9-.3 1.3.1.4.2.9.4 1.3ZM1182.7 938.715c-1 1.6-2.2 3-3.3 3.7-.6-.7-1.4-1.1-2.4-1.1h-.1c.1-1.3.8-3.1 2-5 1.9-3 4.3-4.8 5.3-4.2 1 .7.3 3.6-1.5 6.6ZM1177.2 947.315v.3c0 1.3.7 3.2 1.9 5.1 1.8 3 4.1 4.9 5.2 4.3 1-.6.5-3.6-1.4-6.6-1.1-1.9-2.5-3.4-3.6-4.1-.5.6-1.2.9-2.1 1ZM1176.4 941.415c-.8.2-1.5.7-1.9 1.3-1.2-.6-2.6-2-3.9-4-1.9-2.9-2.6-5.9-1.6-6.5 1-.7 3.4 1.2 5.3 4.1 1.3 1.9 2 3.8 2.1 5.1Z",
    stroke: "#C7AA3D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1177.2 947.315h-.1c-1 0-1.8-.4-2.4-1.1-1 .7-2.2 2-3.2 3.7-1.9 3-2.6 5.9-1.5 6.6 1 .7 3.4-1.2 5.3-4.2 1.1-1.7 1.8-3.4 2-4.7-.1-.2 0-.2-.1-.3Z",
    stroke: "#C7AA3D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgLandscape;